module.exports = __webpack_public_path__ + "static/media/LIEN-BNB.aedea49f.svg";